import type { ReactNode } from "react";

import { faClose } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Typography } from "@mui/material";
import styled from "styled-components";

interface Props {
  header: ReactNode;
  onClose: () => void;
}

export const Header: React.FC<Props> = ({ header, onClose }) => {
  return (
    <StyledHeader>
      <Typography variant="h3">{header}</Typography>
      <IconButton onClick={() => onClose()} size="small">
        <FontAwesomeIcon icon={faClose} size="sm" />
      </IconButton>
    </StyledHeader>
  );
};

export const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 16px 24px;
`;

export const CloseButton = styled.div`
  cursor: pointer;
`;
